import { Details, Dropdown } from '@digdir/designsystemet-react';

import styled from '../../../../../styled';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-8);
  max-width: var(--content-width);
  width: 100%;
  margin: var(--ds-size-8) auto;
`;

export const PageHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--ds-size-2);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--ds-size-2);
`;

export const AttestHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledDropdownButton = styled(Dropdown.Button)`
  border-radius: var(--ds-border-radius-md);
`;

export const StyledDetailsContent = styled(Details.Content)`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-8);
`;
